import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import { getLocales, Language } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { getLossCodeCategoryNames } from 'module/claims/helper/LossCode.Category';
import { LossCodeAction, useLossCodeProvider } from '../LossCode.Hooks';
import { getLineItemLabel } from 'module/claims/helper/LineItem.Label';

export default function LossCodeList() {
  const { lang, currentLanguage } = getLocales();
  const { listApi, pageRouter, permissions } = useLossCodeProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.lossCodes}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple} data-loading={listApi.isExecuting ? true : undefined}>
      <thead>
        <tr>
          <th data-actions></th>
          <th>{lang.code}</th>
          <th>{lang.description}</th>
          <th>{lang.category}</th>
          <th>{lang.sectionCode}</th>
          <th>{lang.disabled}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: lossCode }) => (
            <tr key={lossCode.id}>
              <td>
                {lossCode.isInternalOnly ? (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.error, backgroundColor: Theme.Color.errorLight }}
                  >
                    {lossCode.isInternalOnly ? lang.internalOnly : undefined}
                  </Box>
                ) : undefined}
              </td>
              <td>{lossCode.code}</td>
              <td>
                <b>
                  {(currentLanguage === Language.english ? lossCode.descnEn : (lossCode.descFr ?? lossCode.descnEn)) ??
                    'N/A'}
                </b>
              </td>
              <td>{getLossCodeCategoryNames(lossCode).join(', ')}</td>
              <td>{getLineItemLabel(lossCode.sectionCode)}</td>
              <td>{lossCode.isDisabled ? lang.yes : lang.no}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lossCode.id.toString(),
                      action: LossCodeAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LOSSCODE}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                    media={<Icon class="fas-edit" />}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lossCode.id.toString(),
                      action: LossCodeAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LOSSCODE}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                    media={<Icon class="fas-trash" />}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
